import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import CookieBanner from "../components/CookieBanner";
import { Helmet } from "react-helmet";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { legalText, legalSlugs } from "../text/legal";

const LegalPage = ({ type }) => {
  let { lang } = useParams();
  if (!lang) lang = "ro";

  const valid = lang === "ro" || lang === "ru" || lang === "en" ? lang : "ro";
  const content = legalText[valid][type];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [valid]);

  return (
    <div className="bg-cyan-50 overflow-x-hidden font-bold font-['Manrope']">
      <Helmet>
        <title>{`${content.title} | Selik`}</title>
        <meta name="description" content={content.metaDescription} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={`https://selik.md/${valid}/${legalSlugs[valid][type]}`} />
        <link rel="alternate" hrefLang="ro" href={`https://selik.md/ro/${legalSlugs.ro[type]}`} />
        <link rel="alternate" hrefLang="ru" href={`https://selik.md/ru/${legalSlugs.ru[type]}`} />
        <link rel="alternate" hrefLang="en" href={`https://selik.md/en/${legalSlugs.en[type]}`} />
      </Helmet>
      <div className="relative">
        <div className="bg-gradient-to-b from-[#003E47] to-[#60c6c4] h-[280px] md:h-[340px] rounded-b-[32px] px-3 mr-4 w-full md:w-[calc(100%-16px)] relative top-[-96px] mb-[-96px]" />
        <Navbar />
        <h1 className="relative z-10 px-8 md:px-20 text-3xl md:text-5xl lg:text-6xl text-white w-full max-w-6xl mx-auto md:mt-[-210px] mt-[-200px] pb-2">
          {content.title}
        </h1>
      </div>
      <main className="w-4/5 md:w-3/5 mx-auto pb-20 pt-4">
        <p className="font-[satoshi,'Manrope'] font-normal text-sm text-muted-foreground mb-10">
          {content.lastUpdate}
        </p>
        {content.sections.map((section, i) => (
          <section key={i} className="mb-10">
            <h2 className="text-2xl md:text-3xl text-[#003E47] mb-4">
              {section.heading}
            </h2>
            {(section.paragraphs || []).map((p, j) => (
              <p
                key={`p${j}`}
                className="font-[satoshi,'Manrope'] font-normal text-base md:text-lg text-emerald-950/80 mb-3 leading-relaxed"
              >
                {p}
              </p>
            ))}
            {section.list && (
              <ul className="font-[satoshi,'Manrope'] font-normal text-base md:text-lg text-emerald-950/80 mb-3 list-disc pl-6 space-y-1">
                {section.list.map((li, j) => (
                  <li key={`li${j}`}>{li}</li>
                ))}
              </ul>
            )}
            {(section.paragraphs2 || []).map((p, j) => (
              <p
                key={`p2${j}`}
                className="font-[satoshi,'Manrope'] font-normal text-base md:text-lg text-emerald-950/80 mb-3 leading-relaxed"
              >
                {p}
              </p>
            ))}
          </section>
        ))}
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
};

export default LegalPage;
